import React, { useEffect, useRef, useState } from 'react'
import Tools from '../../../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { GameDataConfig, SingleScenarioConfig } from '../../../../cvp-webgames-core/Misc/interfaces';
import { getGlobalTextSizeStyle, getSaveData, PageType, parseDynamicHtml, saveGame, setFocus, setLast508WindowId, TextHtmlTagType } from '../../../../misc/tools';
import { BaseConfig } from '../../../BaseConfig';
import Button1 from '../../../general/button1';
import Button2 from '../../../general/button2';
import Checkbox1 from '../../../general/checkbox1';
import PopUp1 from '../../../general/pop-up1';
import PopUp2 from '../../../general/pop-up2';
import ProgressBar1 from '../../../general/progress-bar1';
import ProgressBar2 from '../../../general/progress-bar2';

import "./start-scenarios-window.css"
import CoreArrow1 from '../../../../cvp-webgames-core/Components/ui/react/core-arrow1';
import CoreArrow2 from '../../../../cvp-webgames-core/Components/ui/react/core-arrow2';
import MediaControlsUI from '../../../ui/media-controls-ui';
import AlertUI from '../../../ui/alert-ui';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../../../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import { MainMenuWindow508Type, set508Window } from '../../../../pages/MainMenu';


class StartScenariosWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'scenario-hero',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'lock-locked',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/lock-locked.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'lock-unlocked',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/lock-unlocked.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'scen-icon',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/scenario-icon.svg'
			}
		];
	}
}

export const startScenariosWindowCaching = new StartScenariosWindowCaching();

let gameData: GameDataConfig = null;

interface SingleScenarioInfoConfig {
    scenarioId: PageType;
}

var heroUrl = startScenariosWindowCaching.getItemByKey('scenario-hero').src;

let scenariosInfo: SingleScenarioInfoConfig[] = [
	
];

const savedScenarios = getSaveData().scenarios;

for(var i = 0; i < savedScenarios.length; i++) {
	scenariosInfo.push({
		scenarioId: savedScenarios[i].scenarioWindow,
	})
}

const getScenarioIndxFromPageType = (pageType: PageType) => {
	for(var indx = 0; indx < scenariosInfo.length; indx++) {
		if(scenariosInfo[indx].scenarioId === pageType) {
			return {indx: indx, info: scenariosInfo[indx]};
		}
	}
}
let modalScenarioIndx: number;
export const getCompletionPercentage = (scenario: SingleScenarioConfig) => {
	return scenario.score / scenario.maxScore;
}
const StartScenariosWindow = (props: StartScenariosWindowConfig) => {
	if(!gameData) {
		gameData = getSaveData();
	}

	const allUnlockedScenarios = gameData.scenarios.filter((s) => !s.isLocked);
	const lastUnlockedScenario = allUnlockedScenarios[allUnlockedScenarios.length - 1];
	const lastUnlockedScenarioIndx = scenariosInfo.findIndex((s) => s.scenarioId === lastUnlockedScenario.scenarioWindow);
	const [showModal, setShowModal] = useState(false);
	const [showModalCompleted, setShowModalCompleted] = useState(false);
	const [lastScenarioUnlockedIndex, setLastScenarioUnlockedIndex] = useState(lastUnlockedScenarioIndx);
	const [selectedScenarioIndex, setSelectedScenarioIndex] = useState(-1);
	const root = useRef(null);
	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])
	

	const updateSelectedScenarioIndex = (indx: number) => {
		props.animation.setState(AnimationState.Out, ()=> {
			Tools.updateWindow(scenariosInfo[indx].scenarioId);
			// setSelectedScenarioIndex(indx)
		});
	}

	const renderContent = () => {
		return (
			<div ref={root} style={{
				width: '1000px',
				height: '100%',
				position: 'absolute',
				top: '50%',
				left: '50%'
			}} className={props.animation.getInitialClass()}>
				<AllScenariosWindow 
					lastScenarioUnlockedIndex={lastScenarioUnlockedIndex}
					allScenarios={gameData.scenarios} 
					onReturnToPreviousMenuClicked={props.onReturnToPreviousMenuClicked}
					getCompletionPercentage={getCompletionPercentage}
					onScenarioSelected={(pageType: PageType, isNextScenario: boolean) => {
						var savedData = getSaveData();
						const indx = getScenarioIndxFromPageType(pageType).indx;
						modalScenarioIndx = indx;
						const onDone = () => {
							updateSelectedScenarioIndex(indx);
						}
						if(savedData.scenarios[indx].isCompleted) {
							set508Window(MainMenuWindow508Type.AlertUI);
							setShowModalCompleted(true);
						}
						else if(savedData.scenarios[indx].area >= 0) {
							set508Window(MainMenuWindow508Type.AlertUI);

							setShowModal(true);
						} else {
							onDone();
						}
					}}></AllScenariosWindow>
			</div>
		)
	}

	const resetCurrentScenario = () => {
		var savedData = getSaveData();

		savedData.scenarios[modalScenarioIndx].area = -1;
		savedData.scenarios[modalScenarioIndx].aarEntries = [];
		savedData.scenarios[modalScenarioIndx].score = 0;
		savedData.scenarios[modalScenarioIndx].isCompleted = false;
		savedData.scenarios[modalScenarioIndx].gaugeValue = savedData.scenarios[modalScenarioIndx].gaugeMax;

		saveGame(savedData);
		gameData = null;
	}

	return (
		<div className="modal-disable-select start-scenarios-window-container" style={{
		}}>
			{renderContent()}
			{showModalCompleted ? (
				<AlertUI parameters={{
					htmlContent: `This scenario has already been completed with a passing score. Would you like to restart this scenario? Your previous score will be lost.`,
					okButton: {
						onClick: () => {
							set508Window(MainMenuWindow508Type.Main);
							resetCurrentScenario();
							updateSelectedScenarioIndex(modalScenarioIndx);
							setShowModalCompleted(false)
						},
						title: 'Yes'
					},
					noBttn: {
						onClick: () => {
							setShowModalCompleted(false)
						},
						title: 'No'
					},
					title: 'Scenario Already Completed'
				}}></AlertUI>
			) : (null)}
			{showModal ? (
				<AlertUI parameters={{
					htmlContent: `There appears to be another scenario in progress. If you proceed, the saved data for the in progress scenario will be erased. Would you like to proceed?`,
					okButton: {
						onClick: () => {
							set508Window(MainMenuWindow508Type.Main);
							resetCurrentScenario();
							updateSelectedScenarioIndex(modalScenarioIndx);
							setShowModal(false)
						},
						title: 'Yes'
					},
					noBttn: {
						onClick: () => {
							setShowModal(false)
						},
						title: 'No'
					},
					title: 'Scenario In Progress'
				}}></AlertUI>
			) : (null)}
		</div>
	);

};

const AllScenariosWindow = (props: AllScenariosWindowConfig) => {
	const selectedScenario = props.allScenarios[props.lastScenarioUnlockedIndex];
	if(getSaveData().isMotionEnabled) {
		setTimeout(() => {
			document.getElementsByTagName('video')[0].play();
		}, 50);
	}

	const [focusSet, setFocusSet] = useState(false);
	if(!focusSet) {
		setTimeout(() => {
			setFocus('all-scenarios-window-top');
		}, 1000);
		setFocusSet(true);
	}
	return (
		<div className="modal-disable-select start-scenarios-window-container" style={{
		}}>
			<PopUp1
				title= {constants.projectTitle}
				buttons={[
					{
						imgSrc: startScenariosWindowCaching.getItemByKey('return1').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Return to Previous Menu",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onReturnToPreviousMenuClicked
					}
				]}
				onRenderContent={() => {
					return (
						<div className='start-scenarios-all-scenarios-container'>
							<p className='default-text center-element-horizontal white-text' style={{
								textAlign:'center',
								width: '100%'
							}}>
								<span className='title-text2'>Start Scenarios</span>
								<br />
								Please select a scenario to start.	
							</p>

							<div className='start-scenarios-scenario-list'>
								{gameData.scenarios.map((scenario: SingleScenarioConfig, indx: number) => {
									if(indx === props.lastScenarioUnlockedIndex) {
										return (
											<div key={Tools.generateGuid()} className='start-scenarios-last-unlocked-scenario main-content-inner' aria-label={selectedScenario.scenarioWindow.toString() + '. ' + Math.round(props.getCompletionPercentage(selectedScenario) * 100) + '% completed.'}>
												<div className='start-scenarios-last-unlocked-scenario-checkbox-container center-element-vertical'>
													<img alt='' src={startScenariosWindowCaching.getItemByKey('scen-icon').src} />
												</div>
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='default-text'>
													{selectedScenario.scenarioWindow.toString()}
												</p>

												<br />
												<div className='start-scenarios-last-unlocked-scenario-progresss-container center-element-horizontal'>
													<ProgressBar1 title='Scenario Progress' textColor='black' percentage={props.getCompletionPercentage(selectedScenario)}></ProgressBar1>
												</div>
												<div className='start-scenarios-last-unlocked-scenario-continue-bttn'> 
													<Button2 backgroundColor='#157F2F' hoverBgColor='#0b491a' idFor508='all-scenarios-window-top' ariaLabel='Start Scenario' height='100%' onClick={() => {
														props.onScenarioSelected(scenariosInfo[props.lastScenarioUnlockedIndex].scenarioId, true);
													}} width='100%' isSelected={false} onRenderContent={(isHovering: boolean) => {
														return (
															<CoreArrow1 isHovering={isHovering} bgColor='white' hoverColor='white'></CoreArrow1>
														);
													}}></Button2>
												</div>
											</div>
										);
									}
									return (
										<div key={Tools.generateGuid()} className={scenario.isLocked ? ('start-scenarios-single-scenario-container-locked main-content-inner') : ('start-scenarios-single-scenario-container main-content-inner')} aria-label={scenario.scenarioWindow.toString() + '. ' + Math.round(props.getCompletionPercentage(scenario) * 100) + '% completed. Locked'} >
											<div className='start-scenarios-single-scenario-checkbox-container center-element-vertical'>
												<img alt='' src={startScenariosWindowCaching.getItemByKey('scen-icon').src} />
											</div>
											<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='small-text center-element-vertical start-scenarios-single-scenario-title black-text'>
												{scenario.scenarioWindow.toString()}
											</p>
											<div className='start-scenarios-single-scenario-progresss-container center-element-vertical'>
												<ProgressBar2 percentage={props.getCompletionPercentage(scenario)}></ProgressBar2>
											</div>
											<div className={scenario.isLocked ? ('start-scenarios-single-scenario-continue-bttn') : ('start-scenarios-single-scenario-continue-bttn')}>
												{scenario.isLocked ? (
													<Button2 ariaLabel='Start Scenario' height='100%' onClick={() => {
														props.onScenarioSelected(scenario.scenarioWindow, false);
													}} style={{
														backgroundColor: 'lightgray'
													}}
													isDisabled={scenario.isLocked}
													hoverBgColor={constants.design.hoverColor2}
													width='100%' isSelected={false} onRenderContent={() => {
														return (
															<div className='start-scenarios-single-scenario-continue-bttn-img center-element' style={{width: '27px'}}>
																<img alt={scenario.isLocked ? 'locked' : 'unlocked'} aria-label={'Scenario is ' + (scenario.isLocked ? 'locked' : 'unlocked')} src={startScenariosWindowCaching.getItemByKey(`lock-${scenario.isLocked ? 'locked' : 'unlocked'}`).src} />
															</div>
														);
													}}></Button2>
												) : (
													<div className='main-content-inner'>
														{scenario.isCompleted ? (
															<Button2 ariaLabel='Start Scenario' height='100%' onClick={() => {
																props.onScenarioSelected(scenario.scenarioWindow, false);
															}}
															hoverBgColor={constants.design.hoverColor2}
															width='100%' isSelected={false} onRenderContent={() => {
																return (
																	<span className="scenario-checkmark">
																		<div className="scenario-checkmark_stem"></div>
																		<div className="scenario-checkmark_kick"></div>
																	</span>
																);
															}}></Button2>
														) : (
															<Button2 ariaLabel='Start Scenario' height='100%' onClick={() => {
																props.onScenarioSelected(scenario.scenarioWindow, false);
															}}
															hoverBgColor={constants.design.hoverColor2}
															width='100%' isSelected={false} onRenderContent={() => {
																return (
																	<CoreArrow2></CoreArrow2>
																);
															}}></Button2>
														)}
													</div>
												)}
											</div>
										</div>
									)
								})}
							</div>
						</div>
						);
				}}></PopUp1>
		</div>
	);
};

export interface StartScenariosWindowConfig extends BaseConfig {
	animation: AnimationPage;
	onReturnToPreviousMenuClicked: () => void;
	onStartScenarioClicked: (page: PageType, scenarioIndx: number) => void;
	updateWindow: (windowToUse: PageType) => void;
}

export interface AllScenariosWindowConfig {
	lastScenarioUnlockedIndex: number;
	allScenarios: SingleScenarioConfig[];
	onReturnToPreviousMenuClicked: () => void;
	getCompletionPercentage: (scenario: SingleScenarioConfig) => number;
	onScenarioSelected: (pageType: PageType, isNextScenario: boolean) => void;
}

export default StartScenariosWindow;